import { useState } from "react";

import { CurrencyWithDiscount, Disclosure, Hr } from "@chef/components";
import { language } from "@chef/constants";
import { useLoyalty } from "@chef/state-management/hooks";

import { CurrencyWrapper as Currency } from "../../CurrencyWrapper";

import { Chevron } from "./Chevron";
import { intl } from "./DeliveryFee.Intl";

interface DeliveryFeeProps {
  customerFee: number;
  hasFreeShipping: boolean;
}

const FreeDeliveryFee = ({ customerFee }: { customerFee: number }) => {
  const [expanded, setExpanded] = useState(false);

  const { data: loyaltyData } = useLoyalty();

  const currentLevelLabel = loyaltyData?.currentLevelLabel.toLocaleLowerCase();

  return (
    <Disclosure
      open={expanded}
      onClick={() => setExpanded(!expanded)}
      HeaderRow={() => (
        <div className="flex justify-between grow">
          <div className="flex items-center">
            <p>
              {intl.DELIVERY} ({currentLevelLabel})
            </p>

            <Chevron className={expanded ? "rotate-180" : undefined} />
          </div>

          <CurrencyWithDiscount
            trimDecimal
            total={0}
            discount={customerFee}
            language={language}
            horizontal
          />
        </div>
      )}
    >
      {intl.WE_OFFER_FREE_SHIPPING_TO_GOLD_MEMBERS}
    </Disclosure>
  );
};

export const DeliveryFee = ({
  customerFee,
  hasFreeShipping,
}: DeliveryFeeProps) => {
  return (
    <>
      <Hr className="my-4" />

      {hasFreeShipping ? (
        <FreeDeliveryFee customerFee={customerFee} />
      ) : (
        <div className="flex justify-between">
          <p>{intl.DELIVERY}</p>

          <Currency trimDecimal>{customerFee}</Currency>
        </div>
      )}
    </>
  );
};
